import { render, staticRenderFns } from "./FacilityTable.vue?vue&type=template&id=d63bf31e"
import script from "./FacilityTable.vue?vue&type=script&lang=ts"
export * from "./FacilityTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports